// extracted by mini-css-extract-plugin
export default {"base":"vp_aTwDu","main":"vp_asUKS","fullscreen":"vp_mcYrJ"};